
/**********************************************************
 *  Imports
 **********************************************************/

// React
import React, { Component } from "react";
import { Helmet } from "react-helmet";

// Components
import { Chart } from './';

// Stores
import { ChartStore } from '../../Stores';

// Styles
import "./charts.css";

/**********************************************************
 * 
 *  Charting is the parent class in the /charts page.
 *  It holds all of the charting components in full screen
 * 
 **********************************************************/

class Charting extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/

    constructor(props) {

        //console.log('Charting.constructor()');

        super(props);

        this.state = {
            width: window.innerWidth,
            height: window.innerHeight
        };

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/
    
    // Given a new screen size, assess if its worth changing and change it
    updateScreenSize(newSize) {
        
        //console.log('Chart.updateScreenSize()');

        this.setState((prevState, props) => {
            return {
                width : newSize.windowWidth,
                height : newSize.windowHeight
            }
        });

    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {
    
        // Retrieve chart properties
        var chartProps = ChartStore.getChartProperties();
    
        chartProps.height = this.state.height - 150;

        // mobile
        if(this.props.mobile) {
            chartProps.width = (this.state.width - 20);
            chartProps.ticks.x = Math.floor(chartProps.width / 50);
            chartProps.ticks.y = Math.floor(chartProps.height / 50);
            chartProps.candlesAppearance.number = 28;
            chartProps.candlesAppearance.widthRatio = 0.66;
            chartProps.volumeHeight = chartProps.height * 0.15;
            chartProps.margin.right = 50;
            chartProps.ohlcSettings.fontSize = 11;
            chartProps.ohlcSettings.left = 0;
            chartProps.ohlcSettings.top = 0;
            //chartProps.zoomEvent = false;
        }
        else {
            chartProps.width = (this.state.width - 40) * 0.85;
            chartProps.ticks.x = Math.floor(chartProps.width / 50);
            chartProps.ticks.y = Math.floor(chartProps.height / 50);
            chartProps.candlesAppearance.number = 55;
            chartProps.volumeHeight = chartProps.height * 0.15;
        }
        
        //console.log('Charting.render()');
        
        return (

            <div className="page-container chart-holder">

                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Yety | Charts - Cryptocurrency Trading and Analytics Platform - Beautiful, Real-Time Charting with Advanced Trading Overlays</title>
                    <link rel="canonical" href="https://yety.io/charts" />
                    <meta name="keywords" content="cryptocurrency, trading, analytics, pnl, profit, loss, holdings, assets, margin, positions, orders, kraken, poloniex, BTC, ETH, LTC, XRP, DASH, BCH EUR, USD, CAD"/>
                    <meta name="description" content="Yety Charting has beautiful, real-time charts available with one minute, one hour and one day timeframes for four major cryptocurrency exchanges: Coinbase, Poloniex, Kraken and Bittrex. With full-screen, responsive charts, Yety gives you the nicest charts at home and on the go. Check out the advanced trading overlays like EMA and Bollinger Bands too." />
                    
                    <meta property="og:url" content="https://yety.io/charts" />
                    <meta property="og:title" content="Yety | Charts - Cryptocurrency Trading and Analytics Platform" />
                    <meta property="fb:app_id" content="378120756002310" />
                    <meta property="twitter:title" content="Yety | Charts - Cryptocurrency Trading and Analytics Platform" />
                </Helmet>
                
                <Chart properties={chartProps} mobile={this.props.mobile}/>

            </div>

        );
    }
}

export default Charting;





// WEBPACK FOOTER //
// ./src/Views/Charting/Charting.js